module.exports = __webpack_public_path__ + "static/media/icon-login-google.0444b03f.svg";